import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  defaultBackground: 'bg1',
};

const backgroundSlice = createSlice({
  name: 'background',
  initialState,
  reducers: {
    setDefaultBackground: (state, action) => {
      state.defaultBackground = action.payload;
    },
  },
});

export const { setDefaultBackground } = backgroundSlice.actions;

// Selectors
export const selectDefaultBackground = (state) => state.background.defaultBackground;

export default backgroundSlice.reducer;